import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, AlertTriangle, Loader2 } from "lucide-react";

/**
 * Public unsubscribe page hit from broadcast email links.
 * The token param identifies which guest_favorite record to disable.
 */
export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, already: false, baker: null, err: "" });

  useEffect(() => {
    if (!token) { setState({ loading: false, ok: false, already: false, baker: null, err: "Missing token" }); return; }
    api.get(`/broadcasts/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((r) => setState({ loading: false, ok: true, already: !!r.data.already_unsubscribed, baker: r.data.baker_username || null, err: "" }))
      .catch((e) => setState({ loading: false, ok: false, already: false, baker: null, err: e.response?.data?.detail || "Something went wrong" }));
  }, [token]);

  return (
    <div className="min-h-[80vh] grid place-items-center p-6" data-testid="unsubscribe-page">
      <div className="w-full max-w-md cp-card p-6 text-center">
        {state.loading ? (
          <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#857163]" />
        ) : state.ok ? (
          <>
            <CheckCircle2 className="w-10 h-10 text-[#8EAC50] mx-auto mb-3" />
            <div className="font-semibold text-[#3B2C24] text-lg">
              {state.already ? "You're already unsubscribed" : "You're unsubscribed"}
            </div>
            <p className="mt-2 text-sm text-[#857163]">
              {state.baker
                ? <>You won't get any more updates from <b>@{state.baker}</b>.</>
                : "You won't get any more updates from this baker."}
              <br />
              Changed your mind? Visit the map and favorite them again to re-subscribe.
            </p>
            <Link to="/find-a-baker" className="mt-6 inline-block cp-btn-primary text-sm">
              Open the Baker Map
            </Link>
          </>
        ) : (
          <>
            <AlertTriangle className="w-10 h-10 text-[#C2185B] mx-auto mb-3" />
            <div className="font-semibold text-[#3B2C24] text-lg">Couldn't unsubscribe</div>
            <p className="mt-2 text-sm text-[#857163]">{state.err || "This link may have expired."}</p>
            <Link to="/find-a-baker" className="mt-6 inline-block text-[#FF7E67] hover:underline text-sm font-semibold">
              &larr; Back to the map
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
